import LocationUtils from "../util/location-utils";
import Modal from "./modal";

export default class FindContractors {

    constructor(root) {
        this.container = root;
        this.locationButton = this.container.querySelector('.target');
        this.zipInput = this.container.querySelector('.search-wrapper > input[type=search]');
        this.findButton = this.container.querySelector('.search-container > button');
        this.modal = new Modal(this.container.querySelector('.modal'));

        this.registerListeners();
    }

    registerListeners() {
        this.locationButton.addEventListener('click', () => this.handleLocationButtonClicked(this));
    }

    handleLocationButtonClicked(instance) {
        instance.toggleProgress(true);

        LocationUtils.getZipCode(zip => {
            instance.zipInput.value = zip;
            instance.toggleProgress(false);
        }, e => {
            console.error(e);
            instance.toggleProgress(false);
        });
    }

    toggleProgress(isVisible) {
        if(isVisible) {
            this.modal.open();
            this.modal.toggleProgress(true);
        } else {
            this.modal.toggleProgress(false);
            this.modal.close();
        }
    }

}